// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"72f696bf","535":"b292e896","667":"be6e01d1","977":"b1bc98f6"}[chunkId] + ".chunk.js";
};